<template>
    <div class="sketch-content flex">
        <div class="page-content">
            <SketchBreadcrumb pageName="Bugetul proiectului"></SketchBreadcrumb>
            <div class="padding-box">
                <BugetContent :rightFrameOpen="rightFrameOpen" :max-budget="maxBudget" @budgetStatus="handleBudgetStatus($event)"></BugetContent>
            </div>
        </div>
    </div>
</template>

<script>
    import BugetContent from '../components/buget/BugetContent'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'

    export default {
        components: {
            BugetContent,
            SketchBreadcrumb
        },
        props:{
            rightFrameOpen: null
        },
        computed: {
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
        },
        methods: {
            handleBudgetStatus(event){
                this.section = {
                    section: 'buget'
                }

                if(event) {
                    this.$store.dispatch('pages/addPage', this.section)
                }
                else {
                    this.$store.dispatch('pages/removePage', this.section)
                }
            }
        }
    }
</script>

<style scoped>
    .sketch-breadcrumb + .padding-box{
        height: 100%;
    }
    .space-between{
        justify-content: space-between;
    }
    .white-box{
        background: #fff;
        padding: 20px;
    }
    .module-title{
        margin: 0;
        color: #5b6276;
        font-size: 14px;
        margin-bottom: 5px;
    }
    .white-box{
        width: 100%;
    }
    .white-box p{
        color: #777e90;
        font-size: 12px;
        margin: 0;
        max-width: 960px;
    }
    .warning-sign{
        margin-left: 50px;
    }

</style>
